import { calculateHeartRate } from 'util/reduxDuck/TestResultDuckUtil';

import { OptimisticEventDataUpdateForBeats } from '@type/optimisticUpdate/type';
import { BeatType } from '@type/ecgEventType/baseEventType';

import {
  ReqBody,
  UpdateReqOptionProps,
  eventReviewOptimisticEventDataUpdateForBeatEvent,
} from '../optimisticEventDataUpdateForBeatEvent';
import { Command } from '../../eventUpdateCmdPattern';

export class DeleteBeat extends eventReviewOptimisticEventDataUpdateForBeatEvent {
  result: any;
  reqParam: any;

  constructor(reqParam: any) {
    super();
    this.reqParam = reqParam;
  }

  optimisticEventDataUpdate({
    updateReqOption,
    filterBeatsNEctopicList,
  }: UpdateReqOptionProps) {
    let result: OptimisticEventDataUpdateForBeats = {
      hr: [],
      beatType: [],
      waveformIndex: [],
    };
    const { reqBody } = updateReqOption;
    const mergedBeatsNEctopicList: OptimisticEventDataUpdateForBeats =
      this.mergeBeatsNEctopicList(filterBeatsNEctopicList);

    // STEP1: beatUpdate
    result = this.updateLogic({ reqBody, mergedBeatsNEctopicList });

    this.result = this.setOptimisticEventDataUpdateResult({
      isValidationSuccessful: true,
      result,
    });
  }

  updateLogic({
    reqBody,
    mergedBeatsNEctopicList,
  }: {
    reqBody: ReqBody;
    mergedBeatsNEctopicList: OptimisticEventDataUpdateForBeats;
  }): OptimisticEventDataUpdateForBeats {
    const {
      hr: hrList,
      beatType: beatTypeList,
      waveformIndex: waveformIndexList,
    } = mergedBeatsNEctopicList;

    reqBody.waveformIndexes.forEach((updateTargetWaveform) => {
      const updateTargetWaveformIndexIndex = waveformIndexList.findIndex(
        (waveformIndex) => waveformIndex === updateTargetWaveform
      );

      if (updateTargetWaveformIndexIndex > -1) {
        beatTypeList.splice(updateTargetWaveformIndexIndex, 1);
        waveformIndexList.splice(updateTargetWaveformIndexIndex, 1);
        hrList.splice(updateTargetWaveformIndexIndex, 1);

        const isPrevBeatNoise =
          beatTypeList[updateTargetWaveformIndexIndex - 1] === BeatType.NOISE;
        const isNextBeatNoise =
          beatTypeList[updateTargetWaveformIndexIndex] === BeatType.NOISE;

        hrList[updateTargetWaveformIndexIndex] =
          isPrevBeatNoise || isNextBeatNoise
            ? null
            : calculateHeartRate(
                waveformIndexList[updateTargetWaveformIndexIndex],
                waveformIndexList[updateTargetWaveformIndexIndex - 1]
              );
      }
    });

    return mergedBeatsNEctopicList;
  }

  _validation() {}

  getResult() {
    return this.result;
  }
}

// ### COMMAND 역할
export class DeleteBeatCommand {
  command: any;
  executeInst: any;

  constructor(value: any) {
    this.command = new Command(DeleteBeat, null, value);
  }

  *execute() {
    this.executeInst = new this.command.executeClass(this.command.value);
    yield this.executeInst.optimisticEventDataUpdate(this.command.value);
  }

  getResult() {
    return this.executeInst.getResult();
  }
}
